import axios from 'axios';
import i18n from 'i18next';
import getToken from './Token';

const Request = () => {
  const defaultOptions = {
    baseURL: process.env.REACT_APP_API_PATH,
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  };

  // Create instance
  let instance = axios.create(defaultOptions);

  // Set the AUTH token for any request
  instance.interceptors.request.use(config => {
    config.headers.Authorization = `Bearer ${ getToken() }`;
    config.headers.Language = i18n.language;
    return config;
  });

  return instance;
};

export default Request();
